export default __webpack_public_path__ + "static/media/copy-icon.fa101575.svg";